import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import {
    FormControl,
    FormLabel,
    Grid,
    FormControlLabel, TextField, Select, MenuItem,
} from "@mui/material";
import * as React from "react";
import DatePicker from "@mui/lab/DatePicker";
import moment from "moment";
import {ToggleRadioNamed} from "./components";
import {basicInformationSchema} from "./basicInformationsSection";
import {isFunction} from "lodash/lang";
import _ from "lodash";
import {useEffect} from 'react';
import {Autocomplete} from '@mui/lab';
import API from '../../app/api';
import {Consultants} from '../../controls/agyle/dictionaries';

const useStylesReferral = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "32px",
        fontWeight: "500",
        fontSize: "0.95rem",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    }
}))

const useStylesClinical = makeStyles((theme) => ({
}))

export const referralNotesSchema = {
    referralNotes: {
        timeToComeIn: "", //string
        consultant: null, //string
        procedureNotes: "", //string  //on base schema
        infectionControlFlags: "", //string
        physicalSpecReq: "", //string
        additionalReferralNote: "" //string
    }
}

export function ReferralNotesSection(props) {
    const classes = useStylesReferral();
    const {t} = useTranslation();
    const [admission, setAdmission] = React.useState(referralNotesSchema);

    const [consultants, setConsultants] = React.useState([]);
    const signalConsultants = new AbortController();

    useEffect(()=>{
        API.getConsultants(signalConsultants.signal, ``).then(consultants => { //AND bookAdmissionRoles_itemArrays.code eq 'OC'
            setConsultants(consultants.__data);
        })
    },[])

    const handleChange = (field, value) => {
        setAdmission((ad)=>{
            return {
                ...ad,
                referralNotes: {
                    ...ad.referralNotes,
                    [field]: value
                }
            }

        });

        if(props.onChange && isFunction(props.onChange)){
            props.onChange("referralNotes."+field, value);
        }
    }


    useEffect(()=>{
    if(props.admission) {
        setAdmission(props.admission)
    }
    }, [props.admission])

    return (
        <Grid container>
            <Grid item xs={6} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="admission-referral-notes-time-to-com-in-label" className={classes.label}>{t("Time To Come In")}</FormLabel>
                    <TextField
                        disabled={props.disabled}
                        id="admission-referral-notes-time-to-com-in-label"
                        className={classes.notesInput}
                        placeholder={t("Add text here")}
                        value={admission.referralNotes?.timeToComeIn}
                        maxRows={5}
                        multiline
                        onChange={(ev)=>{handleChange('timeToComeIn', ev.target.value)}}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6} sx={{padding: "10px"}} >

                <FormControl sx={{width: "100%", height: 200}} size="small">
                    <FormLabel id="admission-referral-notes-consultant-label" className={classes.label}>{t("Consultant")}</FormLabel>
                    <Consultants
                        name="AdmissionConsultant"
                        size={"large"}
                        disabled={props.disabled}
                        value={admission.referralNotes?.consultant}
                        onChange={(selected) => {
                            if(selected) {
                                let name = selected.title != null ?  selected.title + " " : "";
                                name += selected.firstName != null ? selected.firstName + " " : "";
                                name += selected.familyName != null ? selected.familyName + " " : "";

                                handleChange('consultant', {
                                    id: selected.__id,
                                    specialty: [],
                                    name: name
                                })
                            }
                        }}
                        placeholder={t("Type to see more records")}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="additional-referral-notes-procedure-information-label" className={classes.label}>{t("Additional Procedure/Information")}</FormLabel>
                    <TextField
                        disabled={props.disabled}
                        id="additional-referral-notes-procedure-information"
                        className={classes.notesInput}
                        placeholder={t("Add text here")}
                        value={admission.referralNotes?.procedureNotes}
                        maxRows={10}
                        minRows={10}
                        multiline
                        onChange={(ev)=>{handleChange('procedureNotes', ev.target.value)}}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="additional-referral-notes-infection-control-flags-label" className={classes.label}>{t("Infection Control Flags")}</FormLabel>
                    <TextField id="additional-referral-notes-infection-control-flags" value={admission.referralNotes?.infectionControlFlags}
                               disabled={props.disabled}
                               onChange={(ev)=>{handleChange('infectionControlFlags', ev.target.value)}}/>
                </FormControl>
            </Grid>
            <Grid item xs={6} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="additional-referral-notes-physical-special-req-notes-label" className={classes.label}>{t("Physical/Special Requirements")}</FormLabel>
                    <TextField id="additional-referral-notes-physical-special-req-notes" value={admission.referralNotes?.physicalSpecReq}
                               disabled={props.disabled}
                               onChange={(ev)=>{handleChange('physicalSpecReq', ev.target.value)}}/>
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="additional-referral-notes-note-label" className={classes.label}>{t("Additional Referral Note")}</FormLabel>
                    <TextField
                        id="additional-referral-notes-note"
                        className={classes.notesInput}
                        aria-label="Notes"
                        placeholder={t("Add text here")}
                        value={admission.referralNotes?.additionalReferralNote}
                        maxRows={10}
                        minRows={10}
                        multiline
                        disabled={props.disabled}
                        onChange={(ev)=>{handleChange('additionalReferralNote', ev.target.value)}}
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}

export const clinicalTeamNotesSchema = {
    clinicalTeamNotes: {
        codeTuUse: {
            code: "",
            description: ""
        },
        letterPlease: {
            code: "",
            description: ""
        },
        notes: "",
    }

}

export function ClinicalTeamNotesSection(props) {
    const classes = useStylesClinical();
    const classes2 = useStylesReferral();
    const {t} = useTranslation();
    const [admission, setAdmission] = React.useState(clinicalTeamNotesSchema);
    const dictionaries = props.dictionaries;

    const itemsLetter = [
        {name: "y", display: t("Yes")},
        {name: "n", display: t("No")}
    ]

    const itemsCode = [
        {name: "c1", display: t("Code 1")},
        {name: "c2", display: t("Code 2")}
    ]

    useEffect(()=>{
        if(props.admission) {
            setAdmission(props.admission)
        }
    }, [props.admission])

    const handleChange = (field, value) => {
        setAdmission((ad)=>{
            return {
                ...ad,
                clinicalTeamNotes: {
                    ...ad.clinicalTeamNotes,
                    [field]: value
                }
            }

        });

        if(props.onChange && isFunction(props.onChange)){
            props.onChange("clinicalTeamNotes."+field, value);
        }
    }

    return (
        <Grid container>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl sx={{marginRight: "30px"}}>
                    <FormLabel id="admission-clinic-notes-code-to-use-label" className={classes2.label}>{t("Code To Use")}</FormLabel>
                    <ToggleRadioNamed items={dictionaries?.codeToUse}
                                      disabled={props.disabled}
                                      defaultItemSelected={admission.clinicalTeamNotes?.codeTuUse || dictionaries?.codeToUse[0]}
                                      onChange={(code) => {handleChange('codeTuUse', code)}}/>
                </FormControl>
                <FormControl sx={{}}>
                    <FormLabel id="admission-clinic-notes-letter-please-label" className={classes2.label}>{t("Letter Please")}</FormLabel>
                    <ToggleRadioNamed items={dictionaries?.yesNoDict}
                                      disabled={props.disabled}
                                      defaultItemSelected={admission.clinicalTeamNotes?.letterPlease || dictionaries?.yesNoDict[0]}
                                      onChange={(letter) => {handleChange('letterPlease', letter)}}/>
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl sx={{width: "100%"}}>
                    <FormLabel id="admission-clinic-notes-notes-label" className={classes2.label}>{t("Notes")}</FormLabel>
                    <TextField
                        className={classes2.notesInput}
                        aria-label="Notes"
                        disabled={props.disabled}
                        placeholder={t("Add text here")}
                        value={admission.clinicalTeamNotes?.notes}
                        onChange={(ev)=> {handleChange('notes', ev.target.value)}}
                        maxRows={10}
                        minRows={10}
                        multiline
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}